import { createFileRoute, notFound } from "@tanstack/react-router";

import LandingNotFound from "@/components/landing/LandingNotFound";
import { CONTENT_NOT_FOUND_CACHE_CONTROL } from "@/content/cachePolicy";

/**
 * The prefix has no page. Without this route the layout would answer 200 with
 * an empty `Outlet`, which is a soft 404: the published site serves nothing
 * here, and the five children are reached from the home page's panes.
 */
export const Route = createFileRoute("/use-cases-categories/")({
  loader: () => {
    throw notFound();
  },
  headers: () => ({ "Cache-Control": CONTENT_NOT_FOUND_CACHE_CONTROL }),
  notFoundComponent: LandingNotFound,
});
